import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { SaveFilled } from '@ant-design/icons';
import { SaveActionType } from '@common/constants';

import './save-button.scss';

interface SaveButtonProps {
    disabled: boolean;
    onSavePressed: (returnValue: SaveActionType) => void;
    altButtonText?: string;
    saveActionValue: SaveActionType; // this will be returned upon save
}

const SaveButton = ({ disabled, onSavePressed, altButtonText, saveActionValue }: SaveButtonProps): JSX.Element => {
    const { t } = useTranslation();

    const onButtonClick = () => {
        onSavePressed(saveActionValue);
    };

    return (
        <Button
            disabled={disabled}
            className={`save-button ${disabled ? 'save-button__disabled' : ''}`}
            onClick={onButtonClick}
            type="primary"
            htmlType="submit"
        >
            <SaveFilled /> {altButtonText ?? t('BUTTON.SAVE')}
        </Button>
    );
};

export default SaveButton;
